import { render, staticRenderFns } from "./RideConversation.vue?vue&type=template&id=1f02da48&scoped=true"
import script from "./RideConversation.vue?vue&type=script&lang=js"
export * from "./RideConversation.vue?vue&type=script&lang=js"
import style0 from "./RideConversation.vue?vue&type=style&index=0&id=1f02da48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02da48",
  null
  
)

export default component.exports